<template>
  <router-link
    class="showcase-bottle"
    data-apollo-hover
    data-apollo-hover-animation="scale"
    :style="{ backgroundImage: `url('${image}')` }"
    :to="`/${$store.state.lang}${to}`"
  >
    <div class="showcase-bottle__hover" :style="{ backgroundImage: `url('${imageHover}')` }"></div>
    <div class="showcase-bottle__footer">
      <div class="showcase-bottle__detail">
        <span>BRUT</span>
      </div>
      <div class="showcase-bottle__title">
        <div v-html="name"></div>
      </div>
      <div class="showcase-bottle__discover">
        <div class="showcase-bottle__discover-more">
          <span>{{ $t('discoverMore') }}</span>
        </div>
        <div class="showcase-bottle__discover-action">
          <ArrowBall />
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import ArrowBall from '@/components/ArrowBall.vue';

export default {
  name: 'ShowcaseBottle',

  components: {
    ArrowBall,
  },

  props: ['color', 'name', 'to', 'image', 'imageHover'],
};
</script>

<style lang="scss" scoped>
.showcase-bottle {
    position: relative;
    display: block;
    width: calc(274px * var(--rw));
    height: calc(975px * var(--rw));
    margin: 0 auto;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-bottom: 180px;

    @include mq($until: ipadP) {
      margin-bottom: 80px;
    }

    &__hover {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 100%;
      width: 100%;
      opacity: 0;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      transition: opacity .6s $inOutCubic,
                  transform .6s $inOutCubic;
    }

    &__footer {
      position: absolute;
      bottom: 0px;
      width: 100%;
      z-index: 2;
      transition: opacity .6s $inOutCubic;

      @include mq($until: ipadL) {
        bottom: 40px;
      }
    }

    &__detail {
      font-family: 'IGT Frankling Gothic';
      font-size: rem(22px);
      font-size: calc(22px * var(--rw));
      color: $color-primary;
      font-weight: bold;

      transform: translateY(80px);
      opacity: 0;

      transition: transform .6s $inOutCubic,
                  opacity .6s $inOutCubic;
    }

    &__title {
      font-size: rem(80px);
      font-size: calc(80px * var(--rw));
      color: $color-white;
      font-weight: 300;

      display: flex;

      @include mq($until: ipadL) {
        font-size: rem(60px);
        font-size: calc(60px * var(--rw));
      }

      ::v-deep .stagger {
        transform: translateY(80px);
        opacity: 0;

        transition: transform .6s $inOutCubic,
                    opacity .6s $inOutCubic;
      }
    }

    &__discover {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      transform: translateY(80px);
      opacity: 0;

      transition: transform .6s $inOutCubic,
                  opacity .6s $inOutCubic;

      @include mq($until: ipadP) {
        align-items: center;
      }

      &-action {
        width: calc(70px * var(--rw));
        height: calc(70px * var(--rw));
      }

      &-more {
        color: $color-white;
        opacity: 0.8;
        font-weight: 300;
        font-size: rem(20px);
        font-size: calc(20px * var(--rw));
      }
    }

    @include mq($and: $is-not-touch-device) {
      &:hover {
        .showcase-bottle__hover,
        .showcase-bottle__title ::v-deep .stagger,
        .showcase-bottle__discover {
          opacity: 1;
        }

        .showcase-bottle__title ::v-deep .stagger,
        .showcase-bottle__discover {
          transform: translateY(0px);
          opacity: 1;
        }

        .showcase-bottle__title ::v-deep .stagger {
          &:nth-child(2) {
            transition-delay: .1s;
          }

          &:nth-child(3) {
            transition-delay: .2s;
          }
        }

        .showcase-bottle__discover {
          transition-delay: .2s;
        }

        .showcase-bottle__detail {
          transform: translateY(0px);
          opacity: 1;
        }
      }
    }

    @include mq($and: $is-touch-device) {
      .showcase-bottle__title ::v-deep .stagger,
      .showcase-bottle__discover {
        opacity: 1;
      }

      .showcase-bottle__hover {
        opacity: 0.5;
      }

      .showcase-bottle__title ::v-deep .stagger,
      .showcase-bottle__discover {
        transform: translateY(0px);
        opacity: 1;
      }

      .showcase-bottle__title ::v-deep .stagger {
        &:nth-child(2) {
          transition-delay: .1s;
        }

        &:nth-child(3) {
          transition-delay: .2s;
        }
      }

      .showcase-bottle__discover {
        transition-delay: .2s;
      }

      .showcase-bottle__detail {
        transform: translateY(0px);
        opacity: 1;
      }
    }

    @include mq($until: ipadP) {
      opacity: 1;
      transform: scale(1);

      .showcase-bottle__footer {
        opacity: 1;
      }

      &:after {
        opacity: 1;
      }
    }

    @include mq($and: $is-not-touch-device) {
      &:hover ::v-deep svg circle {
        transform: scale(1);

        &.fill {
          stroke-dashoffset: 0;
          transition: transform .3s $inOutCubic,
                      stroke-dashoffset .3s $inOutCubic .2s;
        }
      }
    }

    @include mq($and: $is-touch-device) {
      & ::v-deep svg circle {
        transform: scale(1);

        &.fill {
          stroke-dashoffset: 0;
          transition: transform .3s $inOutCubic,
                      stroke-dashoffset .3s $inOutCubic .2s;
        }
      }
    }

    & ::v-deep svg circle {
      @include mq($until: ipadP) {
        transform: scale(0);
      }
    }

    @include mq($and: $is-not-touch-device) {
      &:hover ::v-deep .arrow {
        transition: opacity .3s $inOutCubic .2s;
        opacity: 1;

        .arrow-animation {
          animation-name: arrow-loop;
          animation-duration: .8s;
          animation-delay: .3s;
          animation-iteration-count: 1;
          animation-timing-function: $inOutCubic;
        }
      }
    }

    @include mq($until: ipadP) {
      &::v-deep .arrow {
        opacity: 1 !important;
      }
    }
  }
</style>
